var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.2754C0 14.8752 0.324432 14.5508 0.724639 14.5508H15.2754C15.6756 14.5508 16 14.8752 16 15.2754C16 15.6756 15.6756 16.0001 15.2754 16.0001H0.724639C0.324432 16.0001 0 15.6756 0 15.2754Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13626 1.66411e-07C8.53647 -0.000268141 8.86112 0.323946 8.86139 0.724153L8.86864 11.543C8.86891 11.9432 8.54469 12.2679 8.14449 12.2681C7.74428 12.2684 7.41963 11.9442 7.41936 11.544L7.41211 0.725125C7.41184 0.324918 7.73606 0.000268474 8.13626 1.66411e-07Z",
    fill: "#0F20E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50822 6.92408C3.79071 6.6406 4.24952 6.63979 4.53301 6.92228L8.65621 11.031C8.93969 11.3135 8.9405 11.7723 8.65801 12.0558C8.37552 12.3393 7.9167 12.3401 7.63322 12.0576L3.51002 7.94887C3.22653 7.66638 3.22573 7.20757 3.50822 6.92408Z",
    fill: "#0F20E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9893 6.69618C13.2726 6.97893 13.273 7.43775 12.9902 7.72098L8.70036 12.0181C8.41761 12.3013 7.9588 12.3017 7.67557 12.019C7.39234 11.7362 7.39195 11.2774 7.6747 10.9942L11.9646 6.69705C12.2473 6.41382 12.7061 6.41343 12.9893 6.69618Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.fe6561f24a9f22acacf79d7c30e764cf.svg";
export { ForwardRef as ReactComponent };